document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('form[action="/cart/add"].product-form');
  if (!form) return;

  const variants = window.productVariantsTagPrices;

  const formEl = $('form[action="/cart/add"].product-form');
  formEl.on("change", function () {
    let id = $(
      ".product-form .js-options .product__checkbox-input:checked"
    ).data("variant");

    if (!id) {
      id = $(
        ".product__wrapper .product-form .no-js.hide.js-product-selector"
      ).val();
    }

    if (!id) return;

    const variant = variants.find((variant) => `${variant.id}` === `${id}`);
    if (!variant) return;

    const price = document.querySelector("[data-tag-price-discounted-price]");
    const compare = document.querySelector("[data-tag-price-original-price]");
    const stickyPrice = document.querySelector(".sticky-add-to-cart__price");
    const stickyComparePrice = document.querySelector(
      ".sticky-add-to-cart__compare-price"
    );

    const subOption = document.querySelector(
      ".product-form [data-option-subsave] input"
    );
    const onetimeOption = document.querySelector(
      ".product-form [data-option-onetime] input"
    );

    const isSub =
      (subOption && subOption.checked) ||
      (onetimeOption && !onetimeOption.checked);

    if (price) {
      if (isSub) {
        price.innerHTML = variant.sub_price;
      } else {
        price.innerHTML = variant.discounted_price;
      }
    }

    if (compare) {
      if (isSub) {
        compare.innerHTML = variant.original_price;
      } else {
        compare.innerHTML = variant.original_price;
      }
    }

    if (stickyPrice) {
      if (isSub) {
        stickyPrice.innerHTML = variant.sub_price;
      } else {
        stickyPrice.innerHTML = variant.discounted_price;
      }
    }

    if (stickyComparePrice) {
      if (isSub) {
        stickyComparePrice.innerHTML = variant.original_price;
      } else {
        stickyComparePrice.innerHTML = variant.original_price;
      }
    }

    async function getVariantById(variantId) {
      const response = await fetch(`/variants/${variantId}.js`);
      return await response.json();
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    async function variantBuyButtonStatus() {
      const variant_data = await getVariantById(variant.id);
      const variant_button = document.querySelector('#addToCart-klaviyo') || '';
      const klaviyo_button = document.querySelector('.klaviyo_button_out_of_stock') || '';

      if (variant_data.available == true) {
        variant_button.style.display = 'inline-block';
        klaviyo_button.style.display = 'none';
      } else {
        klaviyo_button.style.display = 'inline-block';
        variant_button.style.display = 'none';
      }
    }

    variantBuyButtonStatus();
  });
});
